import { render, staticRenderFns } from "./ModuleBrief.vue?vue&type=template&id=140111c2&scoped=true"
import script from "./ModuleBrief.vue?vue&type=script&lang=js"
export * from "./ModuleBrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140111c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140111c2')) {
      api.createRecord('140111c2', component.options)
    } else {
      api.reload('140111c2', component.options)
    }
    module.hot.accept("./ModuleBrief.vue?vue&type=template&id=140111c2&scoped=true", function () {
      api.rerender('140111c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/modulos/recibos/ModuleBrief.vue"
export default component.exports